/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRange } from './DateRange';
import {
    DateRangeFromJSON,
    DateRangeFromJSONTyped,
    DateRangeToJSON,
    DateRangeToJSONTyped,
} from './DateRange';
import type { DeliveryPattern } from './DeliveryPattern';
import {
    DeliveryPatternFromJSON,
    DeliveryPatternFromJSONTyped,
    DeliveryPatternToJSON,
    DeliveryPatternToJSONTyped,
} from './DeliveryPattern';
import type { RelatedEntity } from './RelatedEntity';
import {
    RelatedEntityFromJSON,
    RelatedEntityFromJSONTyped,
    RelatedEntityToJSON,
    RelatedEntityToJSONTyped,
} from './RelatedEntity';
import type { AdditionalIdentification } from './AdditionalIdentification';
import {
    AdditionalIdentificationFromJSON,
    AdditionalIdentificationFromJSONTyped,
    AdditionalIdentificationToJSON,
    AdditionalIdentificationToJSONTyped,
} from './AdditionalIdentification';
import type { TextMessage } from './TextMessage';
import {
    TextMessageFromJSON,
    TextMessageFromJSONTyped,
    TextMessageToJSON,
    TextMessageToJSONTyped,
} from './TextMessage';

/**
 * 
 * @export
 * @interface GenericBenefit
 */
export interface GenericBenefit {
    /**
     * 
     */
    auth_required?: string;
    /**
     * 
     */
    date_ranges?: Array<DateRange>;
    /**
     * 
     */
    monetary_amount?: number;
    /**
     * 
     */
    delivery_patterns?: Array<DeliveryPattern>;
    /**
     * 
     */
    benefit_time_period_code?: string;
    /**
     * 
     */
    benefit_time_period_code_definition?: string;
    /**
     * 
     */
    quantity?: string;
    /**
     * 
     */
    quantity_qualifier_code?: string;
    /**
     * 
     */
    quantity_qualifier_code_definition?: string;
    /**
     * 
     */
    service_type_code?: string;
    /**
     * 
     */
    service_type_codes?: Array<string>;
    /**
     * 
     */
    procedure_code?: string;
    /**
     * 
     */
    procedure_code_definition?: string;
    /**
     * 
     */
    procedure_modifier_1?: string;
    /**
     * 
     */
    procedure_modifier_definition?: string;
    /**
     * 
     */
    service_type_code_definition?: string;
    /**
     * 
     */
    service_type_code_definitions?: Array<string>;
    /**
     * 
     */
    text_messages?: Array<TextMessage>;
    /**
     * 
     */
    related_entities?: Array<RelatedEntity>;
    /**
     * 
     */
    additional_identifications?: Array<AdditionalIdentification>;
    /**
     * 
     */
    benefit_info_code?: string;
    /**
     * 
     */
    benefit_info_code_definition?: string;
    /**
     * 
     */
    coverage_level_code?: string;
    /**
     * 
     */
    coverage_level_code_definition?: string;
    /**
     * 
     */
    insurance_description?: string;
    /**
     * 
     */
    insurance_type_code?: string;
    /**
     * 
     */
    insurance_type_code_definition?: string;
    /**
     * 
     */
    percent?: number;
    /**
     * 
     */
    in_network?: GenericBenefitInNetworkEnum;
}


/**
 * @export
 */
export const GenericBenefitInNetworkEnum = {
    N: 'N',
    U: 'U',
    W: 'W',
    Y: 'Y',
} as const;
export type GenericBenefitInNetworkEnum = typeof GenericBenefitInNetworkEnum[keyof typeof GenericBenefitInNetworkEnum];


/**
 * Check if a given object implements the GenericBenefit interface.
 */
export function instanceOfGenericBenefit(value: object): value is GenericBenefit {
    return true;
}

export function GenericBenefitFromJSON(json: any): GenericBenefit {
    return GenericBenefitFromJSONTyped(json, false);
}

export function GenericBenefitFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericBenefit {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_required': json['auth_required'] == null ? undefined : json['auth_required'],
        'date_ranges': json['date_ranges'] == null ? undefined : ((json['date_ranges'] as Array<any>).map(DateRangeFromJSON)),
        'monetary_amount': json['monetary_amount'] == null ? undefined : json['monetary_amount'],
        'delivery_patterns': json['delivery_patterns'] == null ? undefined : ((json['delivery_patterns'] as Array<any>).map(DeliveryPatternFromJSON)),
        'benefit_time_period_code': json['benefit_time_period_code'] == null ? undefined : json['benefit_time_period_code'],
        'benefit_time_period_code_definition': json['benefit_time_period_code_definition'] == null ? undefined : json['benefit_time_period_code_definition'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'quantity_qualifier_code': json['quantity_qualifier_code'] == null ? undefined : json['quantity_qualifier_code'],
        'quantity_qualifier_code_definition': json['quantity_qualifier_code_definition'] == null ? undefined : json['quantity_qualifier_code_definition'],
        'service_type_code': json['service_type_code'] == null ? undefined : json['service_type_code'],
        'service_type_codes': json['service_type_codes'] == null ? undefined : json['service_type_codes'],
        'procedure_code': json['procedure_code'] == null ? undefined : json['procedure_code'],
        'procedure_code_definition': json['procedure_code_definition'] == null ? undefined : json['procedure_code_definition'],
        'procedure_modifier_1': json['procedure_modifier_1'] == null ? undefined : json['procedure_modifier_1'],
        'procedure_modifier_definition': json['procedure_modifier_definition'] == null ? undefined : json['procedure_modifier_definition'],
        'service_type_code_definition': json['service_type_code_definition'] == null ? undefined : json['service_type_code_definition'],
        'service_type_code_definitions': json['service_type_code_definitions'] == null ? undefined : json['service_type_code_definitions'],
        'text_messages': json['text_messages'] == null ? undefined : ((json['text_messages'] as Array<any>).map(TextMessageFromJSON)),
        'related_entities': json['related_entities'] == null ? undefined : ((json['related_entities'] as Array<any>).map(RelatedEntityFromJSON)),
        'additional_identifications': json['additional_identifications'] == null ? undefined : ((json['additional_identifications'] as Array<any>).map(AdditionalIdentificationFromJSON)),
        'benefit_info_code': json['benefit_info_code'] == null ? undefined : json['benefit_info_code'],
        'benefit_info_code_definition': json['benefit_info_code_definition'] == null ? undefined : json['benefit_info_code_definition'],
        'coverage_level_code': json['coverage_level_code'] == null ? undefined : json['coverage_level_code'],
        'coverage_level_code_definition': json['coverage_level_code_definition'] == null ? undefined : json['coverage_level_code_definition'],
        'insurance_description': json['insurance_description'] == null ? undefined : json['insurance_description'],
        'insurance_type_code': json['insurance_type_code'] == null ? undefined : json['insurance_type_code'],
        'insurance_type_code_definition': json['insurance_type_code_definition'] == null ? undefined : json['insurance_type_code_definition'],
        'percent': json['percent'] == null ? undefined : json['percent'],
        'in_network': json['in_network'] == null ? undefined : json['in_network'],
    };
}

export function GenericBenefitToJSON(json: any): GenericBenefit {
    return GenericBenefitToJSONTyped(json, false);
}

export function GenericBenefitToJSONTyped(value?: GenericBenefit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_required': value['auth_required'],
        'date_ranges': value['date_ranges'] == null ? undefined : ((value['date_ranges'] as Array<any>).map(DateRangeToJSON)),
        'monetary_amount': value['monetary_amount'],
        'delivery_patterns': value['delivery_patterns'] == null ? undefined : ((value['delivery_patterns'] as Array<any>).map(DeliveryPatternToJSON)),
        'benefit_time_period_code': value['benefit_time_period_code'],
        'benefit_time_period_code_definition': value['benefit_time_period_code_definition'],
        'quantity': value['quantity'],
        'quantity_qualifier_code': value['quantity_qualifier_code'],
        'quantity_qualifier_code_definition': value['quantity_qualifier_code_definition'],
        'service_type_code': value['service_type_code'],
        'service_type_codes': value['service_type_codes'],
        'procedure_code': value['procedure_code'],
        'procedure_code_definition': value['procedure_code_definition'],
        'procedure_modifier_1': value['procedure_modifier_1'],
        'procedure_modifier_definition': value['procedure_modifier_definition'],
        'service_type_code_definition': value['service_type_code_definition'],
        'service_type_code_definitions': value['service_type_code_definitions'],
        'text_messages': value['text_messages'] == null ? undefined : ((value['text_messages'] as Array<any>).map(TextMessageToJSON)),
        'related_entities': value['related_entities'] == null ? undefined : ((value['related_entities'] as Array<any>).map(RelatedEntityToJSON)),
        'additional_identifications': value['additional_identifications'] == null ? undefined : ((value['additional_identifications'] as Array<any>).map(AdditionalIdentificationToJSON)),
        'benefit_info_code': value['benefit_info_code'],
        'benefit_info_code_definition': value['benefit_info_code_definition'],
        'coverage_level_code': value['coverage_level_code'],
        'coverage_level_code_definition': value['coverage_level_code_definition'],
        'insurance_description': value['insurance_description'],
        'insurance_type_code': value['insurance_type_code'],
        'insurance_type_code_definition': value['insurance_type_code_definition'],
        'percent': value['percent'],
        'in_network': value['in_network'],
    };
}

